:host {
  display: block;
}

:host .side-nav {
  background-color: rgb(244 244 244);
}

:host .side-nav-header {
  font-size: 1.5rem;
  margin: 0;
  padding-left: 15px;  
  margin-top: 1rem;
}

:host .side-nav-items {
  padding-top: 0px;
}

:host .hidden {
  display: none
}

:host .expanded {
  display: block;
}